import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type ApplicationSourceIssueState = {
  applicationSourceIssuesById: { [applicationSourceIssueId: number]: ApplicationSourceIssue };
  applicationSourceIssuesStateByOrgId: StateDictionary;
};
type State = { applicationSourceIssues: ApplicationSourceIssueState };

const applicationSourceIssuesByIdSelector = (state: State) =>
  state.applicationSourceIssues.applicationSourceIssuesById;
const applicationSourceIssuesSelector = createSelector(
  [applicationSourceIssuesByIdSelector],
  (applicationSourceIssuesById) => Object.values(applicationSourceIssuesById),
);

export const applicationSourceIssuesForJobIdSelector = createSelector(
  [applicationSourceIssuesSelector, (_state: State, jobId: number) => jobId],
  (applicationSourceIssues, jobId) => applicationSourceIssues.filter((s) => s.jobId === jobId),
);

export const applicationSourceIssuesForOrgIdSelector = createSelector(
  [applicationSourceIssuesSelector, (_state: State, orgId: number) => orgId],
  (applicationSourceIssues, orgId) => applicationSourceIssues.filter((s) => s.Job.orgId === orgId),
);

const applicationSourceIssuesStateByOrgIdSelector = (state: State) =>
  state.applicationSourceIssues.applicationSourceIssuesStateByOrgId;
export const applicationSourceIssuesStateForOrgIdSelector = createSelector(
  [applicationSourceIssuesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (applicationSourceIssuesStateByOrgId, orgId) => applicationSourceIssuesStateByOrgId[orgId],
);
